export default "__VITE_ASSET__DcXRS$0H__"